import React, { useState, useEffect, useRef } from 'react';
import { Search, Filter, Download, RefreshCw, TrendingUp, AlertCircle, CheckCircle2, Clock, Eye, ExternalLink, BarChart3, Activity, Zap, XCircle, Calendar, ChevronLeft, ChevronRight, MapPin, User } from 'lucide-react';
import './styles.css';
import { Crud_Catalogos } from "../../../herramientas/Crud_Catalogos";
import { set } from 'date-fns';

const DashboardMaerskAPI = () => {

    // Obtiene  mes, y dia  del año actual
let dateNow = new Date();

// const month = dateNow.toLocaleString("default", { month: "2-digit" });

// let startDate = `${dateNow.getFullYear()}-${month}-01`;

// const year = dateNow.toLocaleString("default", { year: "numeric" });

// const day = dateNow.toLocaleString("default", { day: "2-digit" });

// // Genera yyyy-mm-dd date string
// const endDate = year + "-" + month + "-" + day;



  const [searchTerm, setSearchTerm] = useState('');
  const [services, setServices] = useState();
  const [filteredServices, setFilteredServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [filterStatus, setFilterStatus] = useState('all');
  const [movementData, setMovementData] = useState(null);
  const [loadingMovement, setLoadingMovement] = useState(false);
  
  // Calendar state
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDateRange, setSelectedDateRange] = useState({ start: dateNow, end: dateNow });
  const [dateFilterMode, setDateFilterMode] = useState('range');
  const [showCalendar, setShowCalendar] = useState(false);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // 5 FRO por página

  //Estado de fechas
  // const [fechaInicio, setFechaInicio] = useState(startDate);
  // const [fechaFin, setFechaFin] = useState(endDate);

  //Estado busqueda
  const [fro, setFro] = useState("");

  //Estado total de paginas
  const [totalPages, setTotalPages] = useState(0);

  // estado total elementos
  const [totalElements,setTotalElements] = useState(0);

  // //Estado totales
  const [totales, setTotales] = useState();

  // const [pageSize,setPageSize] = useState(5);


  //obtenemos los valores iniciales
  const beforePage = useRef(currentPage);
  const beforeDate = useRef(selectedDateRange);
  const beforeFro = useRef(fro);
  


  useEffect(() => {

  


      let params = "";
  
      
      if(!services || validarCambio(currentPage,beforePage) && !fro || (selectedDateRange.end && validarCambio(selectedDateRange,beforeDate)) || fro == ""){
        params   = "fechaInicio=" + formatDateString(selectedDateRange.start)+ "&fechaFin=" +  formatDateString(selectedDateRange.end)  
        let page = currentPage - 1
        if(validarCambio(selectedDateRange,beforeDate)){
            page = 0 ; 
        }
        params  +=  "&page=" + page+ "&size="+ itemsPerPage
        beforePage.current = currentPage;
        //beforeDate.current = selectedDateRange
        getfuntion( "get", [], "", "webhookLog/listado?" +params, "listado" );
      }


      if(!services || selectedDateRange.end && validarCambio(selectedDateRange,beforeDate)){
        params   = "fechaInicio=" + formatDateString(selectedDateRange.start)+ "&fechaFin=" +  formatDateString(selectedDateRange.end)  
        beforeDate.current = selectedDateRange
        getfuntion( "get", [], "", "webhookLog/totales?" +params, "totales" );
      }

   

      if(!validarCambio(fro,beforeFro) && validarCambio(currentPage,beforePage) ){
        let page = (currentPage - 1);
        console.log(beforeFro) 
        beforeFro.current =  fro
        beforePage.current = currentPage;
        // setCurrentPage(1)
        params = "&fro=" + fro + "&page=" + (page) + "&size="+ itemsPerPage
        getfuntion( "get", [], "", "webhookLog/busqueda?" +params, "listado" );
      
      }


      if(validarCambio(fro,beforeFro) && fro !="" ){
        let page = 0;
        console.log(beforeFro) 
        beforeFro.current =  fro
        // setCurrentPage(1)
        params = "&fro=" + fro + "&page=" + (page) + "&size="+ itemsPerPage
        getfuntion( "get", [], "", "webhookLog/busqueda?" +params, "listado" );
      
      }
    
    
    
  }, [currentPage,selectedDateRange,fro]);


  const validarCambio = (estadoActual, estadoAnterior) => {
    return estadoActual !== estadoAnterior.current;
  };

  

  const getfuntion = (
    metodo = "get",
    obj = [],
    id = "",
    catalogo = "",
    stateVar = "",
    hiddenModl = ""
  ) => {
    return Crud_Catalogos(
      catalogo,
      "movimientos",
      metodo,
      id,
      obj,
      "",
      stateVar,
      hiddenModl,
      []
    ).then((returnVal) => {
      switch (metodo) {
        case "post":
          {
            
           
          }
          break;
        case "get":
          {if (stateVar === "listado") {
            setServices(returnVal.content);
            applyFilters(returnVal.content);
            setTotalPages(returnVal.totalPages)
            setTotalElements(returnVal.totalElements)
            setCurrentPage(returnVal.currentPage + 1)
            
          }
          if(stateVar === 'totales'){
            setTotales(returnVal)
          }

          }
          break;
        default:
          break;
      }
    });
  };

  const  applyFilters = (serviceList = services) => {
    let filtered = serviceList;

    if (searchTerm.trim()) {
      filtered = filtered.filter(service => 
        service.uniqueIdentifier.toLowerCase().includes(searchTerm.toLowerCase()) ||
        service.carrierBookingNumber.toLowerCase().includes(searchTerm.toLowerCase()) ||
        service.id.toString().includes(searchTerm)
      );
    }

    if (filterStatus !== 'all') {
      filtered = filtered.filter(service => service.metodo === filterStatus);
    }

    setFilteredServices(filtered);
  };

  useEffect(() => {
    applyFilters();
  }, [searchTerm, filterStatus, dateFilterMode, selectedDate]);

  const formatDateString = (date) => {
    date = tranformDateGMT(date)
    return date.toISOString().split('T')[0];
  };

  const getStatusConfig = (method, hasError) => {
    if (hasError) {
      return { 
        color: '#dc2626', 
        bgColor: '#fef2f2', 
        textColor: '#991b1b', 
        label: 'Error', 
        icon: AlertCircle 
      };
    }

    const configs = {
      create: { 
        color: '#059669', 
        bgColor: '#d1fae5', 
        textColor: '#065f46', 
        label: 'Created', 
        icon: CheckCircle2 
      },
      update: { 
        color: '#2563eb', 
        bgColor: '#dbeafe', 
        textColor: '#1e40af', 
        label: 'Updated', 
        icon: Zap 
      },
      cancel: { 
        color: '#ea580c', 
        bgColor: '#fed7aa', 
        textColor: '#c2410c', 
        label: 'Cancelled', 
        icon: XCircle 
      }
    };
    return configs[method] || configs.create;
  };

  const hasError = (service) => {
    return service.error !== null || (service.response && service.response.includes('Exception'));
  };

  const canViewMovement = (service) => {
    return service.movimiento !== null;
  };

  const getStats = () => {
    const total = filteredServices ? filteredServices.length : 0;
    const errors = filteredServices ? filteredServices.filter(s => hasError(s)).length : 0;
    const successes = total - errors;
    const withMovements = filteredServices ? filteredServices.filter(s => s.movimiento !== null).length : 0;
    return { total, errors, successes, withMovements };
  };

  const invokeMovementAPI = async (service) => {
    
     //setSelectedService(service);

     let data = JSON.parse(service.response);

     console.log(data)
    
      const mockMovementData = {
        id: data.id ,
        status: data.idOperacionEstatus.nombre,
        carrier: data.idCliente.nombre,
        transport: data.idTransportista.nombre,
        origin: data.idLocalidad.nombre,
        destination: data.destino,
        bookingNumber: data.booking,
        idMovimientoTipo: data.idMovimientoTipo.nombre,
        equipmentType: data.contenedorSize,
        contenedor:data.contenedor,
        citaProgramada: data.citaProgramada
      };
      
      setMovementData(mockMovementData);
     
   
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', {
      day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit'
    });
  };

  const getTimeAgo = (dateString) => {
    const diff = Date.now() - new Date(dateString).getTime();
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const days = Math.floor(hours / 24);
    
    if (days > 0) return `${days}d ago`;
    if (hours > 0) return `${hours}h ago`;
    return 'now';
  };

  // Calendar functions
  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDayOfWeek = firstDay.getDay();

    const days = [];
    
    for (let i = startingDayOfWeek - 1; i >= 0; i--) {
      const prevDay = new Date(year, month, -i);
      days.push({ date: prevDay, isCurrentMonth: false });
    }

    for (let day = 1; day <= daysInMonth; day++) {
      days.push({ date: new Date(year, month, day), isCurrentMonth: true });
    }

    const remainingDays = 42 - days.length;
    for (let day = 1; day <= remainingDays; day++) {
      days.push({ date: new Date(year, month + 1, day), isCurrentMonth: false });
    }

    return days;
  };

  // const getServicesForDate = (date) => {
  //   const dateString = formatDateString(date);
  //   return services.filter(service => service.accionFecha.split(' ')[0] === dateString);
  // };

  const isDateSelected = (date) => {
    
    let startDate = (selectedDateRange.start);
    let endDate =  (selectedDateRange.end)
    if (dateFilterMode === 'range') {

      if (!startDate) return false;
      if (!endDate) {
       
        return formatDateString(date) === formatDateString(startDate);
      }
     
      return date >= (startDate) && date <= (endDate);
    }
    return false;
  };


  const tranformDateGMT = (date) =>{
   
   date =  new Date(date);
   let newDate = new Date(date.getTime() - ((1 * 60 * 60 * 1000 ) * 6));
    return newDate
  }
  const handleDateClick = (date) => {

    if (dateFilterMode === 'single') {
      setSelectedDate(date);
    } else if (dateFilterMode === 'range') {
      if (!selectedDateRange.start || (selectedDateRange.start && selectedDateRange.end)) {
        console.log("entro solo una fecha")
        setSelectedDateRange({ start: date, end: null });
       
      } else {
        console.log("2fechas")
        const end = date < selectedDateRange.start ? selectedDateRange.end : date;
        const start = date < selectedDateRange.start ? date : selectedDateRange.start;
        setSelectedDateRange({ start, end });
      }
    }
  };

  const navigateMonth = (direction) => {
    const newDate = new Date(currentDate);
    newDate.setMonth(currentDate.getMonth() + direction);
    setCurrentDate(newDate);
  };

  const clearDateFilters = () => {
    setSelectedDate(null);
    setSelectedDateRange({ start: null, end: null });
    setDateFilterMode('range');
  };

  const groupedServices = () => {
    const groups = {};
    if(!filteredServices){
      return;
    }
    
    filteredServices.forEach(service => {
      if (!groups[service.fro]) {
        groups[service.fro] = [];
      }
      groups[service.fro].push(service);
    });
    
    Object.keys(groups).forEach(key => {
      groups[key].sort((a, b) => new Date(a.accionFecha) - new Date(b.accionFecha));
    });
    
    return groups;
  };

  // Pagination logic
  const grouped = groupedServices();
  const groupedArray = grouped ? Object.entries(grouped) : 0;
  const startIndex = (currentPage) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentPageGroups = groupedArray;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const getVisiblePageNumbers = () => {
    const delta = 2;
    const range = [];
    const rangeWithDots = [];

    for (let i = Math.max(2, currentPage - delta); i <= Math.min(totalPages - 1, currentPage + delta); i++) {
      range.push(i);
    }

    if (currentPage - delta > 2) {
      rangeWithDots.push(1, '...');
    } else {
      rangeWithDots.push(1);
    }

    rangeWithDots.push(...range);

    if (currentPage + delta < totalPages - 1) {
      rangeWithDots.push('...', totalPages);
    } else {
      rangeWithDots.push(totalPages);
    }

    return rangeWithDots.filter((v, i, a) => a.indexOf(v) === i && totalPages > 1);
  };

  const stats = getStats();
  const monthNames = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
  const dayNames = ['D', 'L', 'M', 'M', 'J', 'V', 'S'];

  return (

    
    <div style={{ minHeight: '100vh', backgroundColor: '#f9fafb', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      {/* Header */}
     
     

      <div style={{ backgroundColor: 'white', borderBottom: '1px solid #e5e7eb', position: 'sticky', top: 0, zIndex: 40, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
        <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '1.5rem 1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
            <div style={{ width: '2.5rem', height: '2.5rem', background: 'linear-gradient(135deg, #2563eb 0%, #4f46e5 100%)', borderRadius: '0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Activity style={{ width: '1.5rem', height: '1.5rem', color: 'white' }} />
            </div>
            <div>
              <h1 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#111827', margin: 0, lineHeight: 1.2 }}>FRO Service Monitor</h1>
              <p style={{ fontSize: '0.875rem', color: '#6b7280', margin: 0 }}>Enterprise Service Management con Paginación</p>
            </div>
          </div>
          
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
            <button 
              onClick={() => setShowCalendar(!showCalendar)}
              style={{ 
                display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem 1rem', 
                border: '1px solid #d1d5db', borderRadius: '0.375rem', fontSize: '0.875rem', fontWeight: 500, 
                cursor: 'pointer', transition: 'all 0.2s ease',
                backgroundColor: showCalendar ? '#2563eb' : 'white',
                color: showCalendar ? 'white' : '#374151'
              }}
            >
              <Calendar style={{ width: '1rem', height: '1rem' }} />
              Calendar
            </button>
            
          </div>
        </div>
        </div>
        <div>
        {showCalendar && (
            <div style={{ padding: '1.5rem', borderBottom: '1px solid #e5e7eb' }}>
              <div style={{ maxWidth: '28rem', margin: '0 auto' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem' }}>
                  <h3 style={{ fontSize: '1.125rem', fontWeight: 600, color: '#111827', margin: 0 }}>
                    {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}
                  </h3>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <button onClick={() => navigateMonth(-1)} style={{ padding: '0.25rem', background: 'none', border: 'none', borderRadius: '0.25rem', cursor: 'pointer' }}>
                      <ChevronLeft style={{ width: '1.25rem', height: '4.25rem', color: '#6b7280' }} />
                    </button>
                    <button onClick={() => navigateMonth(1)} style={{ padding: '0.25rem', background: 'none', border: 'none', borderRadius: '0.25rem', cursor: 'pointer' }}>
                      <ChevronRight style={{ width: '1.25rem', height: '1.25rem', color: '#6b7280' }} />
                    </button>
                  </div>
                </div>
                
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '0.25rem', marginBottom: '0.5rem' }}>
                  {dayNames.map(day => (
                    <div key={day} style={{ padding: '0.5rem', textAlign: 'center', fontSize: '0.75rem', fontWeight: 500, color: '#6b7280' }}>{day}</div>
                  ))}
                </div>
                
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '0.25rem' }}>
                  {getDaysInMonth(currentDate).map((day, index) => {

                    // const dayServices = getServicesForDate(day.date);
                    const isSelected = isDateSelected(day.date);
                    const isToday = formatDateString(day.date) === formatDateString(new Date());
                    // {console.log( isSelected)}
                    return (
                      <button
                        key={index}
                        onClick={() => day.isCurrentMonth && handleDateClick(day.date)}
                        disabled={!day.isCurrentMonth}
                        style={{
                          position: 'relative', padding: '0.5rem', fontSize: '0.875rem', height: '2.5rem',
                          background: isSelected ? '#2563eb' : isToday && !isSelected ? '#fef3c7' : '',
                          color: isSelected ? 'white' : isToday && !isSelected ? '#92400e' : day.isCurrentMonth ? '#111827' : '#9ca3af',
                          border: 'none', borderRadius: '0.25rem', cursor: day.isCurrentMonth ? 'pointer' : 'not-allowed',
                          opacity: day.isCurrentMonth ? 1 : 0.3, transition: 'all 0.2s ease'
                        }}
                      >
                        {day.date.getDate()}
                        {/* {dayServices.length > 0 && (
                          <div style={{ position: 'absolute', bottom: '0.125rem', left: '50%', transform: 'translateX(-50%)', width: '0.375rem', height: '0.375rem', backgroundColor: '#dc2626', borderRadius: '50%' }}></div>
                        )} */}
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>
          )}
      </div>
      {totales && 
      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '2rem 1rem' }}>
        {/* Stats Overview */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1.5rem', marginBottom: '2rem' }}>
          {[
            { icon: BarChart3, label: 'Total Servicios creados', value: totales.total, color: '#2563eb', bgColor: '#dbeafe' },
            { icon: CheckCircle2, label: 'Solicitud de Creacion', value: totales.totalCreacion, color: '#059669', bgColor: '#d1fae5' },
            { icon: AlertCircle, label: 'Solicitudes Con cancelacion', value: totales.totalCancelacion, color: '#dc2626', bgColor: '#fee2e2' },
            { icon: TrendingUp, label: 'Solioitudes con actualización', value: totales.totalActualizacion, color: '#7c3aed', bgColor: '#e9d5ff' }
          ].map((stat, index) => (
            <div key={index} style={{ backgroundColor: 'white', borderRadius: '0.75rem', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', padding: '1.5rem', transition: 'all 0.2s ease' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <div style={{ width: '3rem', height: '3rem', backgroundColor: stat.bgColor, color: stat.color, borderRadius: '0.75rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <stat.icon style={{ width: '2rem', height: '2rem' }} />
                </div>
                <div>
                  <p style={{ fontSize: '0.875rem', fontWeight: 500, color: '#6b7280', margin: '0 0 0.25rem 0' }}>{stat.label}</p>
                  <p style={{ fontSize: '2rem', fontWeight: 600, color: '#111827', margin: 0, lineHeight: 1 }}>{stat.value}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        
      </div>
}
{filteredServices && 
  <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '2rem 1rem' }}>
        {/* Search and Filters */}
        <div style={{ backgroundColor: 'white', borderRadius: '0.75rem', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', marginBottom: '2rem' }}>
          <div style={{ padding: '1.5rem', borderBottom: '1px solid #e5e7eb' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div style={{ display: 'flex', flexDirection: window.innerWidth > 640 ? 'row' : 'column', alignItems: window.innerWidth > 640 ? 'center' : 'stretch', justifyContent: 'space-between', gap: '1rem' }}>
                <div style={{ flex: 1, maxWidth: '32rem', position: 'relative' }}>
                  <Search style={{ position: 'absolute', left: '0.75rem', top: '50%', transform: 'translateY(-50%)', color: '#9ca3af', width: '1.25rem', height: '1.25rem' }} />
                  <input
                    type="text"
                    placeholder="Buscar po FRO, Booking Number, o ID"
                    value={fro}
                    onChange={(e) => setFro(e.target.value)}
                    style={{ width: '100%', padding: '0.75rem 0.75rem 0.75rem 2.5rem', border: '1px solid #d1d5db', borderRadius: '0.5rem', fontSize: '1rem' }}
                  />
                </div>
                
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
                
                  
                  {(selectedDate || (selectedDateRange.start && selectedDateRange.end)) && (
                    <button 
                      onClick={clearDateFilters} 
                      style={{ padding: '0.375rem 0.75rem', fontSize: '0.75rem', backgroundColor: '#dc2626', color: 'white', border: 'none', borderRadius: '0.375rem', cursor: 'pointer' }}
                    >
                      Clear Dates
                    </button>
                  )}
                </div>
              </div>

              {dateFilterMode !== 'all' && (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.75rem', backgroundColor: '#dbeafe', borderRadius: '0.5rem' }}>
                  <div>
                    <p style={{ fontSize: '0.875rem', fontWeight: 500, color: '#1e40af', margin: 0 }}>
                      Date Filter: <span style={{ fontWeight: 600 }}>{dateFilterMode === 'single' ? 'Single Date' : 'Date Range'}</span>
                    </p>
                    {selectedDate && dateFilterMode === 'single' && (
                      <p style={{ fontSize: '0.875rem', color: '#2563eb', margin: '0.25rem 0 0 0' }}>Selected: {selectedDate.toLocaleDateString('es-ES')}</p>
                    )}

                    {selectedDateRange.start && dateFilterMode === 'range' && (
                      <p style={{ fontSize: '0.875rem', color: '#2563eb', margin: '0.25rem 0 0 0' }}>
                        Range: {selectedDateRange.start ? (selectedDateRange.start).toLocaleString('es-ES') : ' (select end date)'}
                        {selectedDateRange.end ? ` - ${(selectedDateRange.end).toLocaleString('es-ES')}` : ' (select end date)'}
                      </p>
                    )}
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <p style={{ fontSize: '1.125rem', fontWeight: 600, color: '#1e40af', margin: 0 }}>{filteredServices.length}</p>
                    <p style={{ fontSize: '0.875rem', color: '#2563eb', margin: 0 }}>services found</p>
                  </div>
                </div>
              )}
            </div>
          </div>

          
        </div>

        {/* Pagination Info */}
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1rem' }}>
          <p style={{ fontSize: '0.875rem', color: '#6b7280', margin: 0, padding: '0.5rem 1rem', backgroundColor: '#f9fafb', borderRadius: '0.5rem', border: '1px solid #e5e7eb' }}>
            Showing  {services ? services.length : 0 } of {totalElements} FRO services
          </p>
        </div>

        {/* Services List */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
          {currentPageGroups.map(([fro, services]) => (
            <div key={fro} style={{ backgroundColor: 'white', borderRadius: '0.75rem', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', overflow: 'hidden' }}>
              <div style={{ padding: '1.5rem', backgroundColor: '#f9fafb', borderBottom: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem' }}>
                <div>
                  <h3 style={{ fontSize: '1.125rem', fontWeight: 600, color: '#111827', margin: '0 0 0.25rem 0' }}>FRO: {fro}</h3>
                  <p style={{ fontSize: '0.875rem', color: '#6b7280', margin: 0 }}>{fro} • {services[0].carrier}</p>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
                  <span style={{ padding: '0.25rem 0.75rem', borderRadius: '9999px', fontSize: '0.75rem', fontWeight: 500, backgroundColor: '#dbeafe', color: '#1d4ed8' }}>
                    {services.length} events
                  </span>
                  <span style={{ fontSize: '0.875rem', color: '#6b7280' }}>{services[0].origin} → {services[0].destination}</span>
                </div>
              </div>
              
              <div style={{ borderTop: '1px solid #e5e7eb' }}>
                {services.map((service) => {
                  const config = getStatusConfig(service.metodo, hasError(service));
                  const Icon = config.icon;
                  
                  return (
                    <div key={service.id} style={{ padding: '1.5rem', borderBottom: '1px solid #e5e7eb', transition: 'background-color 0.2s ease' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flex: 1, minWidth: 0 }}>
                          <div style={{ width: '2.5rem', height: '2.5rem', backgroundColor: config.color, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                            <Icon style={{ width: '1.25rem', height: '1.25rem', color: 'white' }} />
                          </div>
                          
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem', flexWrap: 'wrap' }}>
                              <h4 style={{ fontSize: '0.875rem', fontWeight: 600, color: '#111827', margin: 0 }}>
                                {service.metodo.toUpperCase()} #{service.id}
                              </h4>
                              <span style={{ padding: '0.25rem 0.5rem', borderRadius: '9999px', fontSize: '0.75rem', fontWeight: 500, backgroundColor: config.bgColor, color: config.textColor, border: `1px solid ${config.bgColor}` }}>
                                {config.label}
                              </span>
                              {service.priority && (
                                <span style={{ 
                                  padding: '0.25rem 0.5rem', borderRadius: '9999px', fontSize: '0.75rem', fontWeight: 500,
                                  backgroundColor: service.priority === 'high' ? '#fee2e2' : service.priority === 'medium' ? '#fef3c7' : '#d1fae5',
                                  color: service.priority === 'high' ? '#991b1b' : service.priority === 'medium' ? '#92400e' : '#065f46'
                                }}>
                                  {service.priority}
                                </span>
                              )}
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginTop: '0.25rem', flexWrap: 'wrap' }}>
                              <span style={{ fontSize: '0.875rem', color: '#6b7280' }}>{formatDate(service.accionFecha)}</span>
                              <span style={{ fontSize: '0.875rem', color: '#9ca3af' }}>{getTimeAgo(service.accionFecha)}</span>
                              {hasError(service) && (
                                <span style={{ fontSize: '0.875rem', color: '#dc2626', fontWeight: 500 }}>Error: {service.error}</span>
                              )}
                            </div>
                          </div>
                        </div>
                        
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexShrink: 0 }}>
                          {canViewMovement(service) && (
                            <button
                              onClick={() => invokeMovementAPI(service)}
                              disabled={loadingMovement}
                              style={{ 
                                display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.375rem 0.75rem', 
                                fontSize: '0.75rem', fontWeight: 500, backgroundColor: '#059669', color: 'white', 
                                border: 'none', borderRadius: '0.375rem', cursor: 'pointer', opacity: loadingMovement ? 0.5 : 1 
                              }}
                            >
                              {loadingMovement && selectedService?.id === service.id ? (
                                <>
                                  <RefreshCw style={{ width: '0.875rem', height: '0.875rem', animation: 'spin 1s linear infinite' }} />
                                  Loading...
                                </>
                              ) : (
                                <>
                                  <ExternalLink style={{ width: '0.875rem', height: '0.875rem' }} />
                                  View Movement
                                </>
                              )}
                            </button>
                          )}
                          
                          <button
                            onClick={() => setSelectedService(service)}
                            style={{ 
                              display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.375rem 0.75rem', 
                              fontSize: '0.75rem', fontWeight: 500, backgroundColor: 'white', color: '#374151', 
                              border: '1px solid #d1d5db', borderRadius: '0.375rem', cursor: 'pointer' 
                            }}
                          >
                            <Eye style={{ width: '0.875rem', height: '0.875rem' }} />
                            Details
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem', marginTop: '2rem', padding: '2rem 0' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap', justifyContent: 'center' }}>
              <button
                onClick={() => handlePageChange((currentPage  - 1))}
                disabled={currentPage +1 === 1}
                style={{ 
                  display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem 1rem', 
                  backgroundColor: 'white', border: '1px solid #d1d5db', borderRadius: '0.5rem', 
                  color: '#374151', fontSize: '0.875rem', fontWeight: 500, cursor: currentPage  === 1 ? 'not-allowed' : 'pointer',
                  opacity: currentPage  === 1 ? 0.5 : 1
                }}
              >
                <ChevronLeft style={{ width: '1rem', height: '1rem' }} />
                Previous
              </button>
              
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', margin: '0 1rem' }}>
                {getVisiblePageNumbers().map((pageNum, index) => (
                  <React.Fragment key={index}>
                    {pageNum === '...' ? (
                      <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '2.5rem', height: '2.5rem', color: '#9ca3af', fontSize: '0.875rem' }}>...</span>
                    ) : (
                      <button
                        onClick={() => handlePageChange(pageNum)}
                        style={{
                          display: 'flex', alignItems: 'center', justifyContent: 'center', width: '2.5rem', height: '2.5rem',
                          backgroundColor: currentPage === pageNum ? '#2563eb' : 'white',
                          border: `1px solid ${currentPage === pageNum ? '#2563eb' : '#d1d5db'}`,
                          borderRadius: '0.5rem', color: currentPage === pageNum ? 'white' : '#374151',
                          fontSize: '0.875rem', fontWeight: 500, cursor: 'pointer', transition: 'all 0.2s ease'
                        }}
                      >
                        {pageNum}
                      </button>
                    )}
                  </React.Fragment>
                ))}
              </div>
              
              <button
                onClick={() => handlePageChange(Math.min(totalPages, currentPage + 1))}
                disabled={currentPage === totalPages}
                style={{ 
                  display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem 1rem', 
                  backgroundColor: 'white', border: '1px solid #d1d5db', borderRadius: '0.5rem', 
                  color: '#374151', fontSize: '0.875rem', fontWeight: 500, cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                  opacity: currentPage === totalPages ? 0.5 : 1
                }}
              >
                Next
                <ChevronRight style={{ width: '1rem', height: '1rem' }} />
              </button>
            </div>
            
            <div style={{ fontSize: '0.875rem', color: '#6b7280' }}>
              Page {currentPage} of {totalPages}
            </div>
          </div>
        )}

        {/* Empty State */}
        { filteredServices && filteredServices.length === 0 && !loading && (
          <div style={{ textAlign: 'center', padding: '3rem 0' }}>
            <Search style={{ margin: '0 auto 0.5rem', width: '3rem', height: '3rem', color: '#9ca3af' }} />
            <h3 style={{ margin: '0.5rem 0 0.25rem 0', fontSize: '0.875rem', fontWeight: 600, color: '#111827' }}>No services found</h3>
            <p style={{ margin: '0.25rem 0 0 0', fontSize: '0.875rem', color: '#6b7280' }}>
              Try adjusting your search criteria, date filters, or status filters.
            </p>
          </div>
        )}
      </div>
    }

      {/* Movement Details Modal */}
      {movementData && (
        <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(75, 85, 99, 0.75)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem', zIndex: 50 }}>
          <div style={{ backgroundColor: 'white', borderRadius: '0.75rem', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)', width: '100%', maxWidth: '32rem', maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ padding: '1.5rem', borderBottom: '1px solid #e5e7eb' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <h3 style={{ fontSize: '1.125rem', fontWeight: 600, color: '#111827', margin: 0 }}>Movement Details</h3>
                <button onClick={() => setMovementData(null)} style={{ color: '#9ca3af', background: 'none', border: 'none', cursor: 'pointer', padding: '0.25rem', borderRadius: '0.25rem' }}>
                  <XCircle style={{ width: '1.5rem', height: '1.5rem' }} />
                </button>
              </div>
            </div>
            
            <div style={{ padding: '1.5rem' }}>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1.5rem' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                  <div>
                    <label style={{ fontSize: '0.875rem', fontWeight: 500, color: '#374151', margin: 0 }}>ID</label>
                    <p style={{ fontSize: '0.875rem', color: '#111827', margin: '0.25rem 0 0 0' }}>{movementData.id}</p>
                  </div>
                  <div>
                    <label style={{ fontSize: '0.875rem', fontWeight: 500, color: '#374151', margin: 0 }}>Estatus</label>
                    <p style={{ fontSize: '0.875rem', color: '#111827', margin: '0.25rem 0 0 0' }}>{movementData.status}</p>
                  </div>
                  <div>
                    <label style={{ fontSize: '0.875rem', fontWeight: 500, color: '#374151', margin: 0 }}>Cliente</label>
                    <p style={{ fontSize: '0.875rem', color: '#111827', margin: '0.25rem 0 0 0' }}>{movementData.carrier}</p>
                  </div>
                  <div>
                    <label style={{ fontSize: '0.875rem', fontWeight: 500, color: '#374151', margin: 0 }}>Transportista</label>
                    <p style={{ fontSize: '0.875rem', color: '#111827', margin: '0.25rem 0 0 0' }}>{movementData.transport}</p>
                  </div>
                  <div>
                    <label style={{ fontSize: '0.875rem', fontWeight: 500, color: '#374151', margin: 0 }}>Booking Number</label>
                    <p style={{ fontSize: '0.875rem', color: '#111827', margin: '0.25rem 0 0 0' }}>{movementData.bookingNumber}</p>
                  </div>
                </div>
                
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                  <div>
                    <label style={{ fontSize: '0.875rem', fontWeight: 500, color: '#374151', margin: 0 }}>Origen</label>
                    <p style={{ fontSize: '0.875rem', color: '#111827', margin: '0.25rem 0 0 0' }}>{movementData.origin}</p>
                  </div>
                  <div>
                    <label style={{ fontSize: '0.875rem', fontWeight: 500, color: '#374151', margin: 0 }}>Destino</label>
                    <p style={{ fontSize: '0.875rem', color: '#111827', margin: '0.25rem 0 0 0' }}>{movementData.destination}</p>
                  </div>
                  <div>
                    <label style={{ fontSize: '0.875rem', fontWeight: 500, color: '#374151', margin: 0 }}>Cita programada</label>
                    <p style={{ fontSize: '0.875rem', color: '#111827', margin: '0.25rem 0 0 0' }}>{movementData.citaProgramada}</p>
                  </div>
                  <div>
                    <label style={{ fontSize: '0.875rem', fontWeight: 500, color: '#374151', margin: 0 }}>Contenedor</label>
                    <p style={{ fontSize: '0.875rem', color: '#111827', margin: '0.25rem 0 0 0' }}>{movementData.contenedor}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Service Details Modal */}
      {selectedService  && (
        <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(75, 85, 99, 0.75)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem', zIndex: 50 }}>
          <div style={{ backgroundColor: 'white', borderRadius: '0.75rem', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)', width: '100%', maxWidth: '64rem', maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ padding: '1.5rem', borderBottom: '1px solid #e5e7eb' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <h3 style={{ fontSize: '1.125rem', fontWeight: 600, color: '#111827', margin: 0 }}>Service Details</h3>
                <button onClick={() => setSelectedService(null)} style={{ color: '#9ca3af', background: 'none', border: 'none', cursor: 'pointer', padding: '0.25rem', borderRadius: '0.25rem' }}>
                  <XCircle style={{ width: '1.5rem', height: '1.5rem' }} />
                </button>
              </div>
            </div>
            
            <div style={{ padding: '1.5rem' }}>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem', marginBottom: '1.5rem' }}>
                <div>
                  <label style={{ fontSize: '0.875rem', fontWeight: 500, color: '#374151', margin: 0 }}>Service ID</label>
                  <p style={{ fontSize: '0.875rem', color: '#111827', margin: '0.25rem 0 0 0' }}>{selectedService.id}</p>
                </div>
                <div>
                  <label style={{ fontSize: '0.875rem', fontWeight: 500, color: '#374151', margin: 0 }}>Method</label>
                  <p style={{ fontSize: '0.875rem', color: '#111827', margin: '0.25rem 0 0 0' }}>{selectedService.metodo.toUpperCase()}</p>
                </div>
                <div>
                  <label style={{ fontSize: '0.875rem', fontWeight: 500, color: '#374151', margin: 0 }}>Unique Identifier</label>
                  <p style={{ fontSize: '0.875rem', color: '#111827', margin: '0.25rem 0 0 0', fontFamily: 'monospace', backgroundColor: '#f3f4f6', padding: '0.5rem', borderRadius: '0.25rem' }}>{selectedService.uniqueIdentifier}</p>
                </div>
                <div>
                  <label style={{ fontSize: '0.875rem', fontWeight: 500, color: '#374151', margin: 0 }}>Timestamp</label>
                  <p style={{ fontSize: '0.875rem', color: '#111827', margin: '0.25rem 0 0 0' }}>{selectedService.accionFecha}</p>
                </div>
              </div>
              
              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{ fontSize: '0.875rem', fontWeight: 500, color: '#374151', margin: 0 }}>Request</label>
                <div style={{ marginTop: '0.25rem', borderRadius: '0.5rem', padding: '0.75rem', overflowX: 'auto', backgroundColor: '#f9fafb' }}>
                  <pre style={{ fontSize: '0.75rem', whiteSpace: 'pre-wrap', overflowX: 'auto', margin: 0, fontFamily: 'monospace' }}>
                    {selectedService.request}
                  </pre>
                </div>
              </div>
              
              {selectedService.response && (
                <div>
                  <label style={{ fontSize: '0.875rem', fontWeight: 500, color: '#374151', margin: 0 }}>Response</label>
                  <div style={{ 
                    marginTop: '0.25rem', borderRadius: '0.5rem', padding: '0.75rem', overflowX: 'auto', 
                    backgroundColor: hasError(selectedService) ? '#fef2f2' : '#f0fdf4' 
                  }}>
                    <pre style={{ 
                      fontSize: '0.75rem', whiteSpace: 'pre-wrap', overflowX: 'auto', margin: 0, fontFamily: 'monospace',
                      color: hasError(selectedService) ? '#991b1b' : '#166534'
                    }}>
                      {selectedService.response}
                    </pre>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default DashboardMaerskAPI;